<template>
  <div class="date-selector">
    <header>Доступные дни: </header>
    <div v-if="items.length" class="date-list" ref="scroller" @scroll.passive="handleScroll">
      <button class="date"
        @click="selectedItem = item"
        v-for="item in items"
        :key="item.id"
        :class="{ selected: item === selectedItem }">
        <span class="name">ПН</span>
        <span class="day">01.06</span>
      </button>
      <div v-if="rightLoading" class="right-loading">
        <div class="lds-dual-ring"></div>
      </div>
    </div>
    <div v-else class="date-list loading-list">
      <div class="date loading-block" v-for="item in fakeItems" :key="item"></div>
    </div>
  </div>  
</template>

<script>
import Button from '@app/components/uikit/VMButton';
import {} from '@app/services';

export default {
  data: () => ({
    fakeItems: Array.from({ length: 19 }).map((_, i) => i),
    selectedItem: null,
    items: [],
    rightLoading: false,
  }),
  created() {
    this.loadDays();
  },
  methods: {
    async loadDays() {
      const nextItems = await this.getDays();
      this.items = nextItems;
    },
    async getDays() {
      await new Promise(resolve => setTimeout(resolve, 1000));
      return Array.from({ length: 21 }).map((_, i) => ({
        id: this.items.length + i
      }));
    },
    async handleScroll({ target }) {
      const isRight = target.scrollWidth - target.clientWidth === target.scrollLeft;
      if (isRight && !this.rightLoading) {
        console.log('-- load --');
        this.rightLoading = true;
        const days = await this.getDays();
        this.items = [ ...this.items, ...days ];
        this.rightLoading = false;
      }
    },
  }
};
</script>

<style scoped>
header {
  margin: 0 12px;
  color: #555;
}
.date-list {
  display: flex;
  overflow-y: auto;
  padding: 6px;
}
.loading-list {
  overflow: hidden;
}
.date-list::-webkit-scrollbar {
  display: none;
}
.date {
  align-items: flex-start;
  background-color: white;
  border-radius: 4px;
  border: 0;
  display: flex;
  flex-direction: column;
  flex: 0 0 70px;
  height: 70px;
  justify-content: center;
  margin: 6px;
  outline: none;
  padding: 6px;
  color: #464646;
  transition: all 300ms ease;
  box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),
              0 1px 1px 0 rgba(0,0,0,.14),
              0 1px 3px 0 rgba(0,0,0,.12);
}
.name {
  font-weight: 300;
  font-size: 14px;
}
.day {
  font-weight: 500;
  font-size: 18px;
}
.date.selected {
  background: linear-gradient(45deg, rgb(77, 64, 182), rgb(154, 76, 255));
  color: #fff;
}
.loading-block {
  animation-duration: 1.8s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: #ececec;
  background: linear-gradient(to right, #f7f7f7 8%, #ececec 38%, #f7f7f7 54%);
  background-size: 1000px 640px;
  position: relative;
}
@keyframes placeHolderShimmer {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}
.right-loading {
  flex: 1 0 40px;
  height: 70px;
  justify-content: center;
  align-items: center;
  display: flex;
  margin: 6px 0;
}
.lds-dual-ring {
  display: inline-block;
  width: 32px;
  height: 32px;
  overflow: hidden;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 3px solid #ccc;
  border-color: #ccc transparent #ccc transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}


</style>